import { render, staticRenderFns } from "./CompanyPostBar.vue?vue&type=template&id=61e34773"
import script from "./CompanyPostBar.vue?vue&type=script&lang=js"
export * from "./CompanyPostBar.vue?vue&type=script&lang=js"
import style0 from "./CompanyPostBar.vue?vue&type=style&index=0&id=61e34773&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports